import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react'
import Results, { ResultItem } from '../Symbols/Results';
import { SOCIAL_INSURANCE_REDUCTION_THRESHOLD } from '../LegalParameters/Constants';

const formatCurrency = amount => {
	return amount.toLocaleString('cs') + ' Kč';
};

const ResultNumber = styled('span')`
	font-style: italic;
	text-align: right;
`;

const Total = css`
	font-size: 18px;
	font-weight: bold;

	${ResultNumber} {
		color: #ca372c;
	}
`;

export default function StyledResult({ ppm, year }) {
	const rows = [{ name: 'Denní vyměřovací základ:', value: ppm.dvzNonReduced }]
		.concat(
			SOCIAL_INSURANCE_REDUCTION_THRESHOLD[year].map((threshold, index, thresholds) => {
				let previousThreshold = thresholds[index - 1] || 0;
				return {
					name: `${index + 1}. Redukce DVZ (${
						previousThreshold ? `od ${formatCurrency(previousThreshold)} ` : ''
					}do ${formatCurrency(threshold)}):`,
					value: ppm.reduction[index],
				};
			}),
		)
		.concat([
			{ name: 'Redukovaný DVZ:', value: ppm.dvzReduced },
			{ name: 'Mateřská (den):', value: ppm.dvzResult.day, highlighted: true },
			{ name: 'Mateřská (měsíc):', value: ppm.dvzResult.month, highlighted: true },
			{
				name: `Mateřská celkem (${ppm.duration} dní):`,
				value: ppm.dvzResult.total,
				highlighted: true,
			},
		]);
	return (
		<Results data-cy="result">
			{rows.map(({ name, value, highlighted }) => {
				return (
					<ResultItem key={name} name={name} css={highlighted ? Total : null}>
						<ResultNumber>{formatCurrency(value)}</ResultNumber>
					</ResultItem>
				);
			})}
		</Results>
	);
}
